<template>
  <el-dialog custom-class="medium-dialog" title="扫码入库" :visible.sync="dialogFormVisible" center
             :close-on-click-modal="false" :append-to-body="true">
    <div class="search-content">
      <table cellspacing="0" cellpadding="0" border="0" style="border-collapse:collapse;width:100%;" class="query-table">
        <tr>
          <td style="text-align: center;width: 40px">序号</td>
          <td style="text-align: center;width:120px;" v-if="canedit">单号</td>
          <td>名称</td>
          <td style="text-align: center;width:140px;" >规格</td>
          <td style="text-align: center;width:220px;">唯一码</td>
          <td style="text-align: center;width:160px;">批次号</td>
          <!--<td style="text-align: center;width:120px;">有效期</td>-->
        </tr>
        <tr v-for="(item,i) in scancodes">
          <td>{{i+1}}</td>
          <td v-if="canedit">{{item.erpserial}}</td>
          <td>{{item.seedname}}</td>
          <td>{{getPackagesize(item.packagesize)}}</td>
          <td>{{item.storegoodsbarcode}}</td>
          <td style="text-align: center;" v-if="!item.storegoodsbarcode"><el-date-picker  style="width:80%" size="mini" v-model="item.starttime" :value-format="'yyyy-MM-dd'" type="date"></el-date-picker>
            <i class="el-icon-bottom" style="cursor: pointer" @click="copyItem(item,i)"></i></td>
          <td style="text-align: center;" v-else>{{formatDate(item.endtime)}}</td>
        </tr>
      </table>
    </div>
    <div slot="footer" class="dialog-footer no-print">
      <el-button @click="hideDialog(false)">取 消</el-button>
      <el-button type="primary" @click="childdialogVisible=true;" v-if="!canedit">打印</el-button>
      <el-button type="primary" @click="saveData" :loading="loading" v-if="canedit">确定入库</el-button>
      <el-input style="width: 130px" ref="inputScan" size="small" v-model="storegoodsbarcode" v-if="canedit&&!noScan" placeholder="扫唯一码"  onfocus="this.select()" @keyup.enter.native="getZyanjingQRCode()"></el-input>
    </div>
    <el-dialog
      title="提示" :append-to-body="true"
      :visible.sync="childdialogVisible"
      width="30%" height="300px">
      <el-alert v-if="canedit"
        :title="alerttitle"
        type="error" :closable="false"
        center
        show-icon>
      </el-alert>
      <div>
        <el-radio-group v-model="status" size="mini">
          <el-radio label="">首行不空</el-radio>
          <el-radio label="1">首行空1格</el-radio>
          <el-radio label="2">首行空2格</el-radio>
        </el-radio-group></div>
      <span slot="footer" class="dialog-footer">
    <el-button @click="childdialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="afterAlert" v-if="canedit">生成&打印</el-button>
    <el-button type="primary" @click="onlyPrint" v-else>打印</el-button>
  </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
  import {listBar,batchSave,printBar,getQRCode,checkBars} from '@/api/set/jxcstoregoodsbar';

  export default {
    name: "QRCodeScan",
    data() {
      return {
        canedit: false,
        childdialogVisible:false,
        loading:false,
        status:'',
        alerttitle:'',
        scancodes: [],
        storegoodsbarcode: '',
        tableData:[],
        dialogFormVisible: false,
        controlData:{},
        needsaveQRCode:false,
        plus:true
      }
    },
    props: {
      noScan: false
    },
    methods: {
      copyItem(item,index) {
        if (!item.starttime) return;
        for (let i = index; i < this.scancodes.length; i++) {
          if (!this.scancodes[i].starttime && !this.scancodes[i].storegoodsbarcode) {
            this.scancodes[i].starttime = item.starttime;
          }
        }
      },
      show(controlData, canedit) {
        this.loading = true;
        this.controlData = controlData; // erpserial,cangkucode,seedcode
        this.tableData=this.controlData.tableData;
        this.scancodes=[];
        this.needsaveQRCode=false;
        this.canedit = canedit;
        this.dialogFormVisible = true;

        if (this.controlData.goods && this.controlData.goods.length > 0) {
          this.scancodes = this.controlData.goods;
        }
        if (controlData.erpserial) {//取临时存储的值
          listBar({inordernum: controlData.erpserial}).then(response => {
            this.loading = false;
            if (response.data.obj.rows.length > 0) {
              this.scancodes = response.data.obj.rows
              this.canedit = false;//保存过值的不能修改
            }
          });
        }else{
          this.loading = false;
        }
        this.$nextTick(() => {
          if (this.$refs.inputScan)
            this.$refs.inputScan.focus();
        })
      },
      hideDialog(haspost) {
        this.dialogFormVisible = false;
      },
      getZyanjingQRCode() {//平台自己生成的二维码
        if(!this.storegoodsbarcode) return;
        this.storegoodsbarcode=this.storegoodsbarcode.replace(/……/g,'^');
        var qrcodeLen = this.storegoodsbarcode.split('^');
        var qrcode = qrcodeLen[qrcodeLen.length - 1]
        this.storegoodsbarcode = '';
        getQRCode({storegoodsbarcode: qrcode}).then(response => {
          if (response.data.code == 0 && response.data.obj) {
            var arr = response.data.obj;
            if (arr.used == 0) {
              this.errorAlert('商品【' + qrcode + '】已在库存中：' + arr.inordernum + '！');
              return;
            }

            var pipei = null;
            //1、匹配 订单号+光度+商品
            for (let j in this.scancodes) {
              if (this.scancodes[j].storegoodsbarcode)//有编码的继续
              {
                if (this.scancodes[j].storegoodsbarcode == qrcode) {
                  this.error('重复扫码【' + qrcode + '】！')
                  return;
                }
                continue;
              }

              if (pipei == null && this.scancodes[j].packagesize == arr.packagesize&& this.scancodes[j].erpserial == arr.outordernum && this.scancodes[j].seedcode == arr.seedcode) {
                pipei = this.scancodes[j];
              }
            }

            //2、匹配 光度+商品
            if(pipei==null) {
              var datas=this.scancodes.filter(sitem => {
                return !sitem.storegoodsbarcode&&sitem.packagesize === arr.packagesize&&sitem.seedcode === arr.seedcode;
              });
              if(datas.length>0){
                pipei = datas[0];
              }
            }

            //3、匹配坏件列表中的
            if(pipei==null) {
              var datas=this.tableData.filter(sitem => {
                return (sitem.totalnumber-sitem.handlenumber>sitem.needhandlenumber)&&sitem.packagesize === arr.packagesize&&sitem.ordernum === arr.outordernum&&sitem.seedcode === arr.seedcode;
              });
              if(datas==null||datas.length==0){
                datas=this.tableData.filter(sitem => {
                  return (sitem.totalnumber-sitem.handlenumber>sitem.needhandlenumber)&&sitem.packagesize === arr.packagesize&&sitem.seedcode === arr.seedcode;
                });
              }
              if(datas.length>0){
                datas[0].needhandlenumber=parseInt(datas[0].needhandlenumber|0)+1;
                pipei = {
                  erpserial:datas[0].ordernum,
                  seedcode: datas[0].seedcode,
                  seedname: datas[0].seedname,
                  packagesize: datas[0].packagesize,
                  storegoodsbarcode: '', starttime: '', endtime: '',
                  pipei:false
                };
                this.scancodes.push(pipei);
              }
            }

            if (!pipei) {
              this.errorAlert('未匹配到商品！')
            } else {
              pipei.storegoodsbarcode = qrcode;
              pipei.starttime = arr.starttime;
              pipei.endtime = arr.endtime;
            }
          } else {
            this.errorAlert('条码【' + qrcode + '】不存在！')
          }
        });
      },
      getPackagesize(Packagesize) {
        if (!Packagesize || Packagesize == '') {
          return '';
        }
        var ps = JSON.parse(Packagesize);
        var rl = '';
        if (ps.type)
          rl = ps.type + '，';
        if (ps.M) {
          return ps.M + '/' + ps.C.replace('/', '');
        }

        return rl + 'S：' + ps.Y + '，C：' + ps.X;
      },
      error(msg, id) {
        this.$message({
          message: msg,
          type: 'error'
        })
        if (id)
          this.$refs[Object.keys(this.$refs)[id]].focus();
      },
      errorAlert(msg){
        this.$alert(msg, '异常', {
          confirmButtonText: '确定',
          type: 'error',
          callback: action => {
            this.$refs.inputScan.focus();
          }
        });
      },
      saveQRCode(erpserial) {
        if (!this.needsaveQRCode) {
          return;
        }
        this.needsaveQRCode = false;
        var saveitem = []
        var needprint = false;
        for (let i in this.scancodes) {
          saveitem.push({
            "inordernum": erpserial,
            "cangkucode": this.controlData.cangkucode,
            "seedcode": this.scancodes[i].seedcode,
            "seedname": this.scancodes[i].seedname,
            "packagesize": this.scancodes[i].packagesize,
            "storegoodsbarcode": this.scancodes[i].storegoodsbarcode,
            "starttime": this.scancodes[i].starttime ? this.scancodes[i].starttime : null,
            "number": 1
          });
          if (!this.scancodes[i].storegoodsbarcode) {
            needprint = true;
          }
        }
        batchSave({formdetails: JSON.stringify(saveitem)}).then(resOrder => {
          if (needprint) {
            this.printBarlist(erpserial);
          }
        });
      },
      onlyPrint(){
        this.childdialogVisible=false;
        this.printBarlist(this.controlData.erpserial);
      },
      printBarlist(erpserial) {
        printBar(erpserial, this.status, null, 1);
      },
      saveData() {
        //判断唯一码是否唯一
        if (this.scancodes.length == 0) {
          this.error('缺失扫码数据！')
          return
        }

        var datas = this.scancodes.filter(sitem => {
          return !sitem.storegoodsbarcode;
        });
        if (datas.length > 0) {
          this.alerttitle = '有 ' + datas.length + ' 条记录无唯一码！';
          this.childdialogVisible = true;
        } else {
          this.afterAlert();
        }
      },
      afterAlert(){
        this.childdialogVisible = false;
        this.needsaveQRCode=true;
        this.dialogFormVisible = false;
        this.$emit("scancodeedit", '');
      },
      setTimeZero(value) {
        return value > 9 ? value : '0' + value;
      },
      formatDate(date) {
        if (!date)
          return '';
        var myDate = new Date(date);
        return this.setTimeZero(myDate.getFullYear()) + '-'+(this.setTimeZero(myDate.getMonth() + 1)) + '-' + this.setTimeZero(myDate.getDate());
      }
    },
    mounted() {
    },
    components: {

    }
  }
</script>


<style scoped>
  .query-table td {
    border: 1px solid #E0DFDF;
    vertical-align: center;
    height: 22px;
    line-height: 16px;
    padding: 2px;
    font-size: 12px;
  }

  .query-table td.content {
    text-align: center;
  }

  .noborder td {
    border: none;
    font-size: 12px;
  }


</style>



// WEBPACK FOOTER //
// src/components/warehouse/QRCodeScanBad.vue